module.exports = __webpack_public_path__ + "img/login_background-2.8d9ce659.svg";